import { useEffect, useState, useRef } from "react";

export const USERNAME_EFFECTS = [
  { id: "none", label: "None" },
  { id: "purple", label: "Violet" },
  { id: "rainbow", label: "Rainbow" },
  { id: "fire", label: "Fire" },
  { id: "ocean", label: "Ocean" },
  { id: "gold", label: "Gold Shimmer" },
  { id: "glow", label: "Neon Glow" },
  { id: "fuzzy", label: "Fuzzy" },
  { id: "glitch", label: "Glitch" },
  { id: "shuffle", label: "Shuffle" },
  { id: "typewriter", label: "Typewriter" },
  { id: "bounce", label: "Bounce" },
];

const CHARS = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%";

function useShuffle(text, enabled) {
  const [out, setOut] = useState(text);
  const frame = useRef(0);
  useEffect(() => {
    if (!enabled) { setOut(text); return; }
    let raf;
    let settled = 0;
    const tick = () => {
      frame.current += 1;
      if (frame.current % 2 === 0) {
        const chars = text.split("").map((c, i) => {
          if (i < settled) return c;
          return c === " " ? " " : CHARS[Math.floor(Math.random() * CHARS.length)];
        });
        setOut(chars.join(""));
        if (frame.current % 8 === 0) settled += 1;
        if (settled > text.length) { settled = 0; frame.current = 0; }
      }
      raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [text, enabled]);
  return out;
}

function useTypewriter(text, enabled) {
  const [out, setOut] = useState(text);
  useEffect(() => {
    if (!enabled) { setOut(text); return; }
    let i = 0;
    let dir = 1;
    const id = setInterval(() => {
      setOut(text.slice(0, i));
      i += dir;
      if (i > text.length) { dir = -1; i = text.length; }
      if (i < 0) { dir = 1; i = 0; }
    }, 180);
    return () => clearInterval(id);
  }, [text, enabled]);
  return out;
}

export default function UsernameEffect({ text, effect = "none", className = "" }) {
  const safe = text || "username";
  const shuffled = useShuffle(safe, effect === "shuffle");
  const typed = useTypewriter(safe, effect === "typewriter");

  let display = safe;
  if (effect === "shuffle") display = shuffled;
  if (effect === "typewriter") display = typed;

  const base = `fx-username fx-${effect} ${className}`;

  if (effect === "glitch") {
    return (
      <span className={base} data-text={safe}>
        {safe}
      </span>
    );
  }

  if (effect === "bounce") {
    return (
      <span className={base} aria-label={safe}>
        {safe.split("").map((c, i) => (
          <span key={i} className="fx-bounce-char" style={{ animationDelay: `${i * 0.07}s` }}>
            {c === " " ? "\u00A0" : c}
          </span>
        ))}
      </span>
    );
  }

  if (effect === "typewriter") {
    return (
      <span className={base}>
        {display || "\u00A0"}
        <span className="fx-caret">|</span>
      </span>
    );
  }

  return <span className={base}>{display}</span>;
}
